/**
 * Converts a CSS length token to pixels, assuming the standard 16px root font size like `pxToRem`.
 *
 * Grid gap tokens (`components.base.grid.gap`) are authored as `rem` strings, but the product card
 * sizes its Cloudinary request in pixels - so a gap has to cross into pixels to be added to a media
 * width. This only ever sizes an asset request, never layout, so the fixed 16px root is safe here.
 * @param value - A `rem` or `px` length token (e.g. `'0.25rem'`, `'2rem'`, `'4px'`).
 * @returns The equivalent pixel value, or `0` for a missing or unparseable token.
 * @category Utils
 */
export const remToPx = (value?: string): number => {
  const parsed = Number.parseFloat(value || '')

  if (Number.isNaN(parsed)) return 0

  return value!.trim().endsWith('px') ? parsed : parsed * 16
}
